<app-survey-thirtyeighty [externalTitle]="title"></app-survey-thirtyeighty>